/* =============================
   Chushi App Main Module
   ============================= */
(function(){
  /* ====== API Sources Declaration ====== */
  // This declares all API sources used by this catalog
  // Used by Shopify admin to generate toggle controls
  const API_SOURCES = {
    'chushi': { name: 'Chushi (Official)', enabled: true, priority: 1 },
    'wuwa02': { name: 'Wuwa02 (Third-party)', enabled: true, priority: 2 },
    'wuwa03': { name: 'Wuwa03 (Third-party)', enabled: true, priority: 3 }
  };
  
  /* ====== Global Constants & State ====== */
  const WUWA01_API_BASE = "https://www.chushi.shop/gamefun/api/game/frontend", GAME_ID = 2;
  const WUWA02_CARD_API = "https://corsproxy.io/?" + encodeURI("http://mxwy.ltd/api/card/?game=鸣潮&tag=五星");
  const WUWA03_CARD_API = "https://corsproxy.io/?http://bssy.top/api/card/?game=%E9%B8%A3%E6%BD%AE&tag=%E4%BA%94%E6%98%9F";
  const WUWA02_SERVER_CARD_API = "https://corsproxy.io/?http://mxwy.ltd/api/card/?tag=%E5%8C%BA%E6%9C%8D&game=%E9%B8%A3%E6%BD%AE";
  const WUWA03_SERVER_CARD_API = "https://corsproxy.io/?http://bssy.top/api/card/?tag=%E5%8C%BA%E6%9C%8D&game=%E9%B8%A3%E6%BD%AE";
  const WUWA02_DECK_API_BASE = "https://corsproxy.io/?http://mxwy.ltd/api/deck/?game=鸣潮&limit=&sid=&deckid=&asort=desc&cards=";
  const WUWA03_DECK_API_BASE = "https://corsproxy.io/?http://bssy.top/api/deck/?game=鸣潮&limit=&sid=&deckid=&asort=desc&cards=";  
  let selected = {};

  /* ====== UI Update Helpers ====== */
  // (Reusable) - Generic UI update helper for selection count
  const updateSelectedUI = () => {
    // selected is now { id: { count, chushiId, wuwaId }, ... }
    const totalCount = Object.values(selected).reduce((sum, sel) => sum + (sel.count || 0), 0);
    document.querySelector("#selectedCount").textContent = totalCount;
  };
  // (Reusable) - Generic UI scroll helper
  const scrollToResults = () => document.querySelector("#results")?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  /* ====== Toast and Clipboard Helpers ====== */
  // (Reusable) - Generic toast notification
  const showToast = () => {
    const toast = document.querySelector("#toast");
    toast.classList.remove('hidden');
    toast.offsetHeight;
    toast.classList.add('show');
    setTimeout(() => { toast.classList.remove('show'); setTimeout(() => toast.classList.add('hidden'), 300); }, 3000);
  };
  // (Reusable) - Generic clipboard copy helper
  const copyToClipboard = text => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(showToast).catch(() => fallbackCopy(text));
    } else fallbackCopy(text);
  };
  // (Reusable) - Fallback clipboard logic for unsupported browsers
  const fallbackCopy = text => {
    const ta = document.createElement('textarea');
    ta.value = text; ta.style.cssText = 'position:fixed;left:-9999px';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); showToast(); } catch(e) { /* console.error('Copy failed:', e); */ }
    document.body.removeChild(ta);
  };
  // (Reusable) - Generic HTML escaping utility
  const escapeHtml = s => String(s||'').replace(/[&<>"]|'/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));

  /* ====== Settings & Translations Initialization ====== */
  let chushiSettings = {translations_json: '{}', images_json: '{}', api_toggles: {}, api_priority: {}};
  try {
    const el = document.getElementById('chushi-app-settings');
    if (el) chushiSettings = JSON.parse(el.textContent);
  } catch(e) { 
    // console.error('[Chushi] Failed to parse settings:', e);
    chushiSettings = {translations_json: '{}', images_json: '{}', api_toggles: {}, api_priority: {}}; 
  }
  
  // console.log('[Chushi] Raw settings from Liquid:', chushiSettings);
  // console.log('[Chushi] API toggles received:', chushiSettings.api_toggles);
  // console.log('[Chushi] API priority received:', chushiSettings.api_priority);
  
  // Override API_SOURCES enabled state from admin settings
  if (chushiSettings.api_toggles) {
    Object.keys(API_SOURCES).forEach(apiId => {
      const oldState = API_SOURCES[apiId].enabled;
      if (chushiSettings.api_toggles.hasOwnProperty(apiId)) {
        API_SOURCES[apiId].enabled = chushiSettings.api_toggles[apiId] === true;
        // console.log(`[Chushi] API '${apiId}': ${oldState} → ${API_SOURCES[apiId].enabled} (admin setting: ${chushiSettings.api_toggles[apiId]})`);
      }
    });
  }
  
  // Override API_SOURCES priority from admin settings
  if (chushiSettings.api_priority) {
    Object.keys(API_SOURCES).forEach(apiId => {
      const oldPriority = API_SOURCES[apiId].priority;
      if (chushiSettings.api_priority.hasOwnProperty(apiId)) {
        const newPriority = parseInt(chushiSettings.api_priority[apiId]);
        if (!isNaN(newPriority) && newPriority > 0) {
          API_SOURCES[apiId].priority = newPriority;
          // console.log(`[Chushi] API '${apiId}' priority: ${oldPriority} → ${newPriority} (admin setting: ${chushiSettings.api_priority[apiId]})`);
        }
      }
    });
  }
  
  // console.log('[Chushi] ═══════════════════════════════════════════');
  // console.log('[Chushi] FINAL API SOURCES STATUS:');
  // Object.entries(API_SOURCES)
  //   .sort(([,a], [,b]) => a.priority - b.priority)
  //   .forEach(([id, api]) => {
  //     console.log(`[Chushi]   [Priority ${api.priority}] ${id}: ${api.enabled ? '✅ ENABLED' : '❌ DISABLED'} (${api.name})`);
  //   });
  // console.log('[Chushi] ═══════════════════════════════════════════');

  let nameTranslations = {}, nameTranslationsMap = {};
  try {
    nameTranslations = JSON.parse(chushiSettings.translations_json || '{}');
    Object.entries(nameTranslations).forEach(([key, val]) => {
      key.split('|').map(k => k.trim()).forEach(k => { if (k) nameTranslationsMap[k] = val; });
    });
  } catch(e) { nameTranslations = {}; nameTranslationsMap = {}; }

  let customImages = {}, customImagesMap = {};
  try {
    customImages = JSON.parse(chushiSettings.images_json || '{}');
    Object.entries(customImages).forEach(([key, val]) => {
      key.split('|').map(k => k.trim()).forEach(k => { if (k) customImagesMap[k] = val; });
    });
  } catch(e) { customImages = {}; customImagesMap = {}; }

  // (Reusable) - There is always a translation from mandarin to english
  const translateName = name => nameTranslationsMap[name] || name;
  // (Reusable) - There is always a image mapping from catalog settings
  const getCustomImage = name => customImagesMap[name] || null;

  /* ====== Utility Functions ====== */
  // (Not Reusable) - ID obfuscation logic that is specific to this app's ID structure
  function privateToPublicID(privateID) {
  if (!privateID) return '';
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const randomChars = len => Array.from({length: len}, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  const reversed = String(privateID).split('').reverse().join('');
  // Swap neighboring pairs in reversed
  let arr = reversed.split('');
  for (let i = 0; i + 1 < arr.length; i += 2) {
    [arr[i], arr[i+1]] = [arr[i+1], arr[i]];
  }
  const swapped = arr.join('');
  return randomChars(2) + swapped + randomChars(2);
}
  // (Reusable) - Generic UI update for selection badge on filter icons
  const updateThumbDisplay = (thumb, id) => {
    // selected[id] is now an object with .count
    const count = selected[id]?.count || 0;
    const existingBadge = thumb.querySelector('.count-badge');

    if (count > 0) {
      thumb.classList.add('selected');
      if (existingBadge) {
        existingBadge.textContent = count;
      } else {
        const badge = document.createElement('div');
        badge.className = 'count-badge';
        badge.textContent = count;
        thumb.querySelector('.thumb-img-container').appendChild(badge);
      }
    } else {
      thumb.classList.remove('selected');
      if (existingBadge) {
        existingBadge.remove();
      }
    }
  };

  // Fetch chushi, wuwa02, and wuwa03 catalogs in parallel (only if enabled)
  // (Not Reusable) - Catalog-specific: fetches, merges, and normalizes multiple APIs; schema and merging logic are tightly coupled to current catalogs
  const loadResources = () => {
    // Build promises array based on enabled APIs
    const resourcePromises = [];
    
    if (API_SOURCES.chushi.enabled) {
      // console.log('[Chushi] Loading Chushi resources');
      resourcePromises.push(fetch(`${WUWA01_API_BASE}/resource/get?game_id=${GAME_ID}`).then(r => r.json()));
    } else {
      // console.log('[Chushi] Skipping Chushi resources (disabled)');
      resourcePromises.push(Promise.resolve({data: {items: []}}));
    }
    
    if (API_SOURCES.wuwa02.enabled) {
      // console.log('[Chushi] Loading Wuwa02 resources');
      resourcePromises.push(fetch(WUWA02_CARD_API).then(r => r.json()));
      resourcePromises.push(fetch(WUWA02_SERVER_CARD_API).then(r => r.json()));
    } else {
      // console.log('[Chushi] Skipping Wuwa02 resources (disabled)');
      resourcePromises.push(Promise.resolve([]));
      resourcePromises.push(Promise.resolve([]));
    }
    
    if (API_SOURCES.wuwa03.enabled) {
      // console.log('[Chushi] Loading Wuwa03 resources');
      resourcePromises.push(fetch(WUWA03_CARD_API).then(r => r.json()));
      resourcePromises.push(fetch(WUWA03_SERVER_CARD_API).then(r => r.json()));
    } else {
      // console.log('[Chushi] Skipping Wuwa03 resources (disabled)');
      resourcePromises.push(Promise.resolve([]));
      resourcePromises.push(Promise.resolve([]));
    }
    
    Promise.all(resourcePromises).then(([payload, wuwaData, wuwa02ServerData, wuwa03Data, wuwa03ServerData]) => {
      let chushiItems = payload?.data?.items || [];
      let wuwaItems = Array.isArray(wuwaData) ? wuwaData : (wuwaData.results || []);
      let wuwa03Items = Array.isArray(wuwa03Data) ? wuwa03Data : (wuwa03Data.results || []);
      // Build serverMap dynamically for wuwa02 and wuwa03
      window._wuwa02ServerMap = {};
      window._wuwa03ServerMap = {};
      if (Array.isArray(wuwa02ServerData)) {
        wuwa02ServerData.forEach(srv => {
          if (srv.name && srv.id) window._wuwa02ServerMap[srv.name] = String(srv.id);
        });
      } else if (wuwa02ServerData.results) {
        wuwa02ServerData.results.forEach(srv => {
          if (srv.name && srv.id) window._wuwa02ServerMap[srv.name] = String(srv.id);
        });
      }
      if (Array.isArray(wuwa03ServerData)) {
        wuwa03ServerData.forEach(srv => {
          if (srv.name && srv.id) window._wuwa03ServerMap[srv.name] = String(srv.id);
        });
      } else if (wuwa03ServerData.results) {
        wuwa03ServerData.results.forEach(srv => {
          if (srv.name && srv.id) window._wuwa03ServerMap[srv.name] = String(srv.id);
        });
      }
      // Merge by normalized name (union)
      function normalizeName(name) {
        return name && name.startsWith('mc5_') ? name.slice(4) : name;
      }
      const merged = {};
      // Add chushi items
      chushiItems.forEach(it => {
        const norm = normalizeName(it.name);
        merged[norm] = { ...it, name: norm, _chushi_id: it.id };
        // console.log(`[normalize/merge] Chushi item: raw='${it.name}', normalized='${norm}', id=${it.id}`);
      });
      // Add wuwa02 items if not already present
      wuwaItems.forEach(it => {
        const norm = normalizeName(it.name);
        if (!merged[norm]) {
          merged[norm] = { ...it, name: norm, id: it.id || it.card_id, _wuwa_id: it.id || it.card_id };
          // console.log(`[normalize/merge] Wuwa02 item: raw='${it.name}', normalized='${norm}', id=${it.id || it.card_id} (new)`);
        } else {
          // Merge image fields if missing
          if (!merged[norm].img_url && it.img_url) merged[norm].img_url = it.img_url;
          if (!merged[norm].role_img && it.role_img) merged[norm].role_img = it.role_img;
          if (!merged[norm].card_img && it.card_img) merged[norm].card_img = it.card_img;
          // Always store wuwa02 card id for mapping
          merged[norm]._wuwa_id = it.id || it.card_id;
          // console.log(`[normalize/merge] Matched: normalized='${norm}' → ChushiID=${merged[norm]._chushi_id}, Wuwa02ID=${it.id || it.card_id}`);
        }
      });
      // Add wuwa03 items if not already present
      if (typeof wuwa03Items !== 'undefined') {
        wuwa03Items.forEach(it => {
          const norm = normalizeName(it.name);
          if (!merged[norm]) {
            merged[norm] = { ...it, name: norm, id: it.id || it.card_id, _wuwa03_id: it.id || it.card_id };
            // console.log(`[normalize/merge] Wuwa03 item: raw='${it.name}', normalized='${norm}', id=${it.id || it.card_id} (new)`);
          } else {
            // Merge image fields if missing
            if (!merged[norm].img_url && it.img_url) merged[norm].img_url = it.img_url;
            if (!merged[norm].role_img && it.role_img) merged[norm].role_img = it.role_img;
            if (!merged[norm].card_img && it.card_img) merged[norm].card_img = it.card_img;
            // Always store wuwa03 card id for mapping
            merged[norm]._wuwa03_id = it.id || it.card_id;
            // console.log(`[normalize/merge] Matched: normalized='${norm}' → ChushiID=${merged[norm]._chushi_id}, Wuwa02ID=${merged[norm]._wuwa_id}, Wuwa03ID=${it.id || it.card_id}`);
          }
        });
      }
      // Filter out unwanted cards before building the filter UI
      const unwanted = new Set(['停驻之烟','擎渊怒涛','浩境粼光','漪澜浮录']);
      function getBaseName(name) {
        return name && name.startsWith('mc5_') ? name.slice(4) : name;
      }
      const allItems = Object.values(merged).filter(card => !unwanted.has(getBaseName(card.name||'')));

      // Store for search mapping
      window._wuwa02Catalog = allItems.filter(it => it._wuwa_id);
      // For Wuwa03, we use the same filter set as Wuwa02 (same design)
      window._wuwa03Catalog = allItems.filter(it => it._wuwa_id); // for symmetry, in case needed later
      // Unified server options from both catalogs
      const serverOptions = [
        {key: '', label: 'All Servers'},
        {key: 'mc_Europe', label: 'Europe', cardId: '13899'},
        {key: 'mc_America', label: 'America', cardId: '13897'},
        {key: 'mc_Asia', label: 'Asia', cardId: '13898'},
        {key: 'mc_SEA', label: 'SEA', cardId: '13901'},
        {key: 'mc_HMT', label: 'HMT', cardId: ''}
      ];
      // Populate server filter dropdown
      const serverSelect = document.querySelector('#serverSelect');
      if (serverSelect && !serverSelect.dataset.initialized) {
        serverSelect.innerHTML = serverOptions.map(opt => `<option value="${opt.key}">${opt.label}</option>`).join('');
        serverSelect.dataset.initialized = 'true';
      }
      const container = document.querySelector("#filters");
      container.innerHTML = '';

      // Deduplicate by translated name
      const dedupedByTranslation = {};
      allItems.forEach(it => {
        const translated = translateName(it.name) || `ID ${it.id}`;
        if (!dedupedByTranslation[translated]) {
          dedupedByTranslation[translated] = { ...it };
        } else {
          // Merge IDs and prefer existing custom image, but fill in missing ones
          const merged = dedupedByTranslation[translated];
          if (!merged._chushi_id && it._chushi_id) merged._chushi_id = it._chushi_id;
          if (!merged._wuwa_id && it._wuwa_id) merged._wuwa_id = it._wuwa_id;
          if (!merged._wuwa03_id && it._wuwa03_id) merged._wuwa03_id = it._wuwa03_id;
          if (!merged.img_url && it.img_url) merged.img_url = it.img_url;
          if (!merged.role_img && it.role_img) merged.role_img = it.role_img;
          if (!merged.card_img && it.card_img) merged.card_img = it.card_img;
        }
      });
      Object.values(dedupedByTranslation).forEach(it => {
        const thumb = document.createElement('div');
        const name = translateName(it.name) || `ID ${it.id}`;
        const customImg = getCustomImage(it.name);
        thumb.className = 'thumb';
        // Store chushi, wuwa02, and wuwa03 IDs for later use
        thumb.dataset.chushiId = it._chushi_id || '';
        thumb.dataset.wuwaId = it._wuwa_id || '';
        thumb.dataset.wuwa03Id = it._wuwa03_id || '';
        // Use a composite key for selection
        const rid = it._wuwa_id || it._chushi_id || it._wuwa03_id || it.id;
        thumb.dataset.rid = rid;
        // For wuwa03, normalize name and apply translation just like wuwa02
        let displayName = name;
        if (it._wuwa03_id) {
          let normName = it.name && it.name.startsWith('mc5_') ? it.name.slice(4) : it.name;
          displayName = translateName(normName) || normName;
        }
        thumb.innerHTML = `
          <div class="thumb-img-container">
            <img alt="${escapeHtml(displayName)}" src="${customImg || it.img_url || it.role_img || it.card_img || ''}" loading="lazy"/>
          </div>
          <div class="label">${escapeHtml(displayName)}</div>
        `;
        thumb.onclick = () => {
          const id = thumb.dataset.rid;
          if (selected[id]) {
            selected[id].count++;
          } else {
            selected[id] = {
              count: 1,
              chushiId: thumb.dataset.chushiId,
              wuwaId: thumb.dataset.wuwaId,
              wuwa03Id: thumb.dataset.wuwa03Id
            };
          }
          updateThumbDisplay(thumb, id);
          updateSelectedUI();
        };
        container.appendChild(thumb);
      });
        updateSelectedUI();
      })
      .catch(err => {
        // console.error("Load failed:", err);
        document.querySelector("#filters").innerHTML = '<div class="no-data">Failed to load character list.</div>';
      });
  };

  /* ====== Search & API Query Logic ====== */
  // (Not Reusable) - Catalog-specific: builds API URLs and parameters based on current catalog schemas and selection state
  const performSearch = () => {
    const resultsEl = document.querySelector("#results");
    resultsEl.innerHTML = '<div class="no-data">Searching…</div>';
    scrollToResults();
    const serverFilter = document.querySelector("#serverSelect").value;
    // chushi-app API
    let chushiUrl = `${WUWA01_API_BASE}/resource/search?game_id=${GAME_ID}` ;
    chushiUrl += `&code=` ; // No code input
    // Remove 'mc_' prefix for chushi API
    let chushiServer = '';
    if (serverFilter === 'mc_America') chushiServer = 'America';
    else if (serverFilter === 'mc_Europe') chushiServer = 'Europe';
    else if (!serverFilter) chushiServer = '';
    chushiUrl += `&description=${encodeURIComponent(chushiServer)}` ;
    // Build groups for chushi using chushi IDs
    const chushiGroups = {};
    Object.values(selected).forEach(sel => {
      if (sel.chushiId) {
        if (!chushiGroups[sel.chushiId]) chushiGroups[sel.chushiId] = 0;
        chushiGroups[sel.chushiId] += sel.count;
      }
    });
    chushiUrl += `&groups=${encodeURIComponent(JSON.stringify(chushiGroups))}` ;
    // wuwa02 API: build cards parameter with wuwa02 IDs
    let wuwaSelectedIds = [];
    Object.values(selected).forEach(sel => {
      if (sel.wuwaId) {
        for (let i = 0; i < sel.count; i++) wuwaSelectedIds.push(sel.wuwaId);
      }
    });
    // wuwa03 API: build cards parameter with wuwa03 IDs (use _wuwa03_id from merged)
    let wuwa03SelectedIds = [];
    Object.values(selected).forEach(sel => {
      if (sel.wuwa03Id) {
        for (let i = 0; i < sel.count; i++) wuwa03SelectedIds.push(sel.wuwa03Id);
      }
    });
    // Add server card ID if a server is selected
    let wuwa02ServerId = window._wuwa02ServerMap && window._wuwa02ServerMap[serverFilter] ? window._wuwa02ServerMap[serverFilter] : '';
    let wuwa03ServerId = window._wuwa03ServerMap && window._wuwa03ServerMap[serverFilter] ? window._wuwa03ServerMap[serverFilter] : '';
    if (serverFilter && (wuwa02ServerId || wuwa03ServerId)) {
      // console.log('[chushi-app] Adding server card ID for wuwa02:', wuwa02ServerId, 'for wuwa03:', wuwa03ServerId);
      if (wuwa02ServerId) wuwaSelectedIds = [wuwa02ServerId, ...wuwaSelectedIds];
      if (wuwa03ServerId) wuwa03SelectedIds = [wuwa03ServerId, ...wuwa03SelectedIds];
    }
    // console.log('[chushi-app] wuwa02 cards parameter:', wuwaSelectedIds.join('|'));
    // console.log('[chushi-app] wuwa03 cards parameter:', wuwa03SelectedIds.join('|'));
    const wuwaUrl = WUWA02_DECK_API_BASE + encodeURIComponent(wuwaSelectedIds.join("|"));
    const wuwa03Url = WUWA03_DECK_API_BASE + encodeURIComponent(wuwa03SelectedIds.join("|"));
    // console.log('[chushi-app] chushiUrl:', chushiUrl);
    // console.log('[chushi-app] wuwaUrl:', wuwaUrl);
    // console.log('[chushi-app] wuwa03Url:', wuwa03Url);
    // Conditionally call APIs based on admin toggle settings
    // console.log('[Chushi] ═══════════════════════════════════════════');
    // console.log('[Chushi] SEARCH: Checking API states...');
    // console.log('[Chushi] Server filter:', serverFilter || 'All Servers');
    
    let chushiPromise;
    const chushiEnabled = API_SOURCES.chushi.enabled;
    const chushiServerSupported = !serverFilter || serverFilter === 'mc_America' || serverFilter === 'mc_Europe';
    // console.log(`[Chushi] Chushi API: enabled=${chushiEnabled}, serverSupported=${chushiServerSupported}`);
    
    if (chushiEnabled && chushiServerSupported) {
      // console.log('[Chushi] ✅ Querying Chushi API:', chushiUrl);
      chushiPromise = fetch(chushiUrl).then(r => r.json());
    } else {
      // console.log('[Chushi] ❌ Skipping Chushi API (disabled or unsupported server)');
      chushiPromise = Promise.resolve({data:{items:[]}});
    }
    
    // Build promises array for parallel fetch
    const apiPromises = [];
    
    // console.log(`[Chushi] Wuwa02 API: enabled=${API_SOURCES.wuwa02.enabled}`);
    if (API_SOURCES.wuwa02.enabled) {
      // console.log('[Chushi] ✅ Querying Wuwa02 API:', wuwaUrl);
      apiPromises.push(fetch(wuwaUrl).then(r => r.json()));
    } else {
      // console.log('[Chushi] ❌ Skipping Wuwa02 API (disabled)');
      apiPromises.push(Promise.resolve({results: []}));
    }
    
    // console.log(`[Chushi] Wuwa03 API: enabled=${API_SOURCES.wuwa03.enabled}`);
    if (API_SOURCES.wuwa03.enabled) {
      // console.log('[Chushi] ✅ Querying Wuwa03 API:', wuwa03Url);
      apiPromises.push(fetch(wuwa03Url).then(r => r.json()));
    } else {
      // console.log('[Chushi] ❌ Skipping Wuwa03 API (disabled)');
      apiPromises.push(Promise.resolve({results: []}));
    }
    // console.log('[Chushi] ═══════════════════════════════════════════');
    
    // Parallel fetch for enabled APIs
    Promise.all(apiPromises)
    .then(([wuwaPayload, wuwa03Payload]) => {
      chushiPromise.then(chushiPayload => {
        // Client-side filter wuwa02 and wuwa03 results by server
        let selectedServer = serverFilter;
        let wuwaResults = wuwaPayload?.results || wuwaPayload?.data?.items || [];
        let wuwa03Results = wuwa03Payload?.results || wuwa03Payload?.data?.items || [];
        if (selectedServer) {
          wuwaResults = wuwaResults.filter(deck => {
            let deckInfo = {};
            try { deckInfo = typeof deck.deck_info === 'string' ? JSON.parse(deck.deck_info) : deck.deck_info; } catch(e) {}
            return deckInfo && Object.keys(deckInfo).some(cardName => cardName === selectedServer);
          });
          wuwa03Results = wuwa03Results.filter(deck => {
            let deckInfo = {};
            try { deckInfo = typeof deck.deck_info === 'string' ? JSON.parse(deck.deck_info) : deck.deck_info; } catch(e) {}
            return deckInfo && Object.keys(deckInfo).some(cardName => cardName === selectedServer);
          });
        }
        renderResults({ chushi: chushiPayload, wuwa: { ...wuwaPayload, results: wuwaResults }, wuwa03: { ...wuwa03Payload, results: wuwa03Results } });
      });
    }).catch(err => {
      // console.error("Search failed:", err);
      resultsEl.innerHTML = '<div class="no-data">Search failed. Please try again.</div>';
    });
  };
  /* ====== Results Rendering ====== */
  // (Not Reusable) - Catalog-specific: rendering logic depends on current API schemas and result formats
  const renderResults = payload => {
    const results = document.querySelector("#results");
    let chushiList = [], wuwaList = [], wuwa03List = [];
    if (payload.chushi) {
      chushiList = (payload.chushi?.data?.items || []).map(acc => ({...acc, _source: 'chushi', _priority: API_SOURCES.chushi.priority}));
    }
    if (payload.wuwa) {
      wuwaList = (payload.wuwa?.results || payload.wuwa?.data?.items || []).map(acc => ({...acc, _source: 'wuwa02', _priority: API_SOURCES.wuwa02.priority}));
    }
    if (payload.wuwa03) {
      wuwa03List = (payload.wuwa03?.results || payload.wuwa03?.data?.items || []).map(acc => ({...acc, _source: 'wuwa03', _priority: API_SOURCES.wuwa03.priority}));
    }
    
    // Combine and sort by priority (lower number = higher priority = shown first)
    const list = [...chushiList, ...wuwaList, ...wuwa03List].sort((a, b) => a._priority - b._priority);
    
    // console.log('[Chushi] ═══════════════════════════════════════════');
    // console.log('[Chushi] RESULTS: Sorted by priority');
    // console.log(`[Chushi] Total results: ${list.length} (Chushi: ${chushiList.length}, Wuwa02: ${wuwaList.length}, Wuwa03: ${wuwa03List.length})`);
    // console.log('[Chushi] Display order:', list.map(acc => `${acc._source}(p${acc._priority})`).slice(0, 10).join(', '), list.length > 10 ? '...' : '');
    // console.log('[Chushi] ═══════════════════════════════════════════');
    
    if (!list.length) return results.innerHTML = '<div class="no-data">No results found.</div>';
    results.innerHTML = '';
    list.forEach(acc => {
      // Handle both schemas
      let items = Array.isArray(acc.items) ? acc.items : [];
      if (!items.length && acc.deck_info) {
        // wuwa02 deck_info is a JSON object: { name: count, ... }
        try {
          const deckInfo = typeof acc.deck_info === 'string' ? JSON.parse(acc.deck_info) : acc.deck_info;
          items = Object.entries(deckInfo).map(([name, count]) => ({ name, count }));
        } catch(e) { items = []; }
      }
      const card = document.createElement('div');
      card.className = 'result-card';
      card.innerHTML = `
        <div class="result-header">
          <div class="result-id">
            <strong>Account ID:</strong> ${escapeHtml(acc._source === 'wuwa02' || acc._source === 'wuwa03' ? (acc.name || '') : privateToPublicID(acc.code||''))}
          </div>
          <button class="copy-btn" onclick="copyToClipboard('${escapeHtml(acc._source === 'wuwa02' || acc._source === 'wuwa03' ? (acc.name || '') : privateToPublicID(acc.code||''))}')">Copy ID</button>
        </div>
        <div class="result-info">
          ${(() => {
            const sourceLabel = acc._source === 'wuwa02' ? 'Wuwa02' : acc._source === 'wuwa03' ? 'Wuwa03' : 'cs';
            let infoText = '';
            if (acc._source === 'wuwa02' || acc._source === 'wuwa03') {
              // Extract Gender and Server from deck_info keys as in wuwa02-catalog-app.js
              let server = '', gender = '', level = '', email = '';
              const src = acc.source || '';
              const deckInfo = acc.deck_info ? (typeof acc.deck_info === 'string' ? (()=>{try{return JSON.parse(acc.deck_info);}catch(e){return {};}})() : acc.deck_info) : {};
              Object.keys(deckInfo||{}).forEach(cardName => {
                if (/^mc_/.test(cardName)) {
                  if (cardName === 'mc_Europe') server = 'Europe';
                  else if (cardName === 'mc_America') server = 'America';
                  else if (cardName === 'mc_Asia') server = 'Asia';
                  else if (cardName === 'mc_SEA') server = 'SEA';
                  else if (cardName === 'mc_HMT') server = 'HMT';
                } else if (/mc5_.*女/.test(cardName)) gender = 'Female';
                else if (/mc5_.*男/.test(cardName)) gender = 'Male';
              });
              // Extract level/email from source
              const emailMatch = src.match(/(企业邮箱|微软邮箱)/);
              if (emailMatch) email = emailMatch[1] === '企业邮箱' ? 'Enterprise' : 'Microsoft';
              const levelMatch = src.match(/等级[:：]([0-9]+)/);
              if (levelMatch) level = levelMatch[1];
              infoText = [
                gender ? `Gender: ${gender}` : '',
                server ? `Server: ${server}` : '',
                level ? `Level: ${level}` : '',
                email ? `Email: ${email}` : ''
              ].filter(Boolean).join(' | ');
            } else {
              const desc = acc.description || items.map(i => i.description||'').filter(Boolean).join(' / ');
              const parts = desc.split(/[-—–]+/).map(s => s.trim());
              if (parts.length < 3) {
                infoText = desc + (desc.includes('Email: Microsoft') ? '' : ' | Email: Microsoft');
              } else {
                let gender = parts[0] === '女' ? 'Female' : parts[0] === '男' ? 'Male' : parts[0];
                infoText = `Gender: ${gender} | Server: ${parts[1]} | Level: ${parts[2]}` + (desc.includes('Email: Microsoft') ? '' : ' | Email: Microsoft');
              }
            }
            // Add source and price to info text
            const priceText = acc.price||acc.amount||acc.money ? `Price: ${escapeHtml(String(acc.price||acc.amount||acc.money))}` : '';
            const parts = [infoText, priceText, sourceLabel].filter(Boolean);
            return parts.join(' | ');
          })()}
        </div>
        <div class="result-main">
          <div class="chars-row">
            ${items.length ? items.filter(ch => {
              // For wuwa02 and wuwa03, filter out server and gender cards
              if (acc._source === 'wuwa02' || acc._source === 'wuwa03') {
                if (/^mc_/.test(ch.name)) return false;
                if (/mc5_.*[男女]$/.test(ch.name)) return false;
              }
              return true;
            }).map(ch => {
              // For wuwa02 and wuwa03, normalize name by stripping mc5_ prefix before translation/image lookup
              let normName = ch.name && ch.name.startsWith('mc5_') ? ch.name.slice(4) : ch.name;
              let displayName, customImg;
              if (acc._source === 'wuwa02' || acc._source === 'wuwa03') {
                displayName = translateName(normName);
                customImg = getCustomImage(normName);
              } else {
                displayName = translateName(ch.name);
                customImg = getCustomImage(ch.name);
              }
              return `<div class="char">
                <img src="${escapeHtml(customImg || ch.img_url || ch.role_img || '')}" alt="${escapeHtml(displayName||'')}" onerror="this.style.opacity=.5"/>
                <div class="cname">${escapeHtml(displayName||'')}</div>
                ${ch.nums||ch.count ? `<div class="cnum">x${escapeHtml(String(ch.nums||ch.count))}</div>`  : ''}
              </div>`;
            }).join('') : '<div class="no-data">No characters data</div>'}
          </div>
        </div>
      `;
      results.appendChild(card);
    });
  };

  /* ====== Event Handlers ====== */
  document.querySelector("#searchBtn").onclick = performSearch;
  document.querySelector("#clearBtn").onclick = () => {
    selected = {};
    document.querySelectorAll('.thumb').forEach(thumb => {
      thumb.classList.remove('selected');
      const badge = thumb.querySelector('.count-badge');
      if (badge) badge.remove();
    });
        document.querySelector("#serverSelect").value = '';
    updateSelectedUI();
    document.querySelector("#results").innerHTML = '';
  };
  /* ====== Expose Helpers & Initialize ====== */
  window.copyToClipboard = copyToClipboard;
  loadResources();
})();
